<template>
<div class="chapter">
<div class="inner_page">
<div class="cover" id="cover">
<div class="coverimg">
<img alt="" src="Images/Cover_0.jpg" style="width: 100%; height: 100%"/>
</div>
</div>
<div class="footnote" id="prelim_footnotes">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?26daa2c2